// extracted by mini-css-extract-plugin
module.exports = {"root":"LabeledBox_root__ciCP-","label":"LabeledBox_label__1VSfs"};